import { Result } from 'entities/result'
import { ReactNode } from 'react'
import { ResultInfoV2, ResultV2ViewModel, RiskData, RiskScore } from './result_v2_view_model'
import { Symptom } from 'components/send_history/result_v2'
import { Sample } from 'entities/sample'

export type EsophagusRiskScore = RiskScore & {
    esophagus_family_history: number
    smoking: number
    alcohol: number
    eating_habits_of_vegetables_and_fruits: number
}

type EsophagusRiskRatio = EsophagusRiskScore

type EsophagusResultInfoV2 = ResultInfoV2 & {
    risk_score: EsophagusRiskScore
    risk_ratio: EsophagusRiskRatio
    risk_data: RiskData<EsophagusRiskScore>
}

export class EsophagusResultV2ViewModel extends ResultV2ViewModel {
    constructor(result: Result, sample: Sample) {
        super(result, '食道がん', '0.1%程度', '1%程度', sample)
    }
    public info(): EsophagusResultInfoV2 {
        return super.info() as EsophagusResultInfoV2
    }

    public esophagus_family_history = () => {
        const hasFamilyHistory = this.background.familyHistories?.some((fh) => (fh.withinFirstDegreeRelative ?? 0) >= 1 && fh.cancer === 'esophagus')
        if (hasFamilyHistory) {
            return '当てはまる'
        } else {
            return '該当なし'
        }
    }

    public smoking = () => {
        if (this.background.smoking === 'now') {
            return '吸う'
        } else if (this.background.smoking === 'ever') {
            return 'やめた'
        } else {
            return '吸わない'
        }
    }

    public alcohol = () => {
        if (this.background.alcoholPerWeek === 0) {
            return '飲まない'
        } else if (this.background.alcoholPerWeek === 0.5) {
            return '月に数日'
        } else {
            return `週に${this.background.alcoholPerWeek}日`
        }
    }

    public eating_habits_of_vegetables_and_fruits = () => {
        if (this.background.eatingHabitsOfVegetablesAndFruits === 'everyday') {
            return 'よく食べる'
        } else {
            return `全く/時々`
        }
    }

    public symptomsView(symptoms: Symptom[]): ReactNode {
        return super.symptomsView(symptoms, 15)
    }

    public getMiddleTextPosition(): { bottom: number; left: number } {
        return { bottom: 135, left: 125 }
    }
    public getHighTextPosition(): { top: number; right: number } {
        return { top: 2, right: 5 }
    }
}
